import { cn } from '@v2/shared/lib/utils';
import { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLSpanElement> {
  /** The number of items in the cart.
   * @default 0 */
  count: number;
}

/**
 * The count on a cart icon.
 *
 * `bg-primary` rather than the `bg-red-600` it carried while it lived in the DiscountMags
 * header: primary resolves to `--v2-primary`, which styles/v2.css sets per brand, so the
 * badge follows whichever brand is drawing it. It reached a second brand the day the sale
 * chrome became shared, and MagSpot is blue and MagZoom purple — a Tailwind-red badge on
 * either is not a shade off, it is the wrong colour. On DiscountMags it moves #DC2626 to
 * the brand's own #CF373C, which is the same correction `shared/components/Button` records
 * having made for the same reason.
 */
export const CartCount = ({ count = 0, className, ...props }: Props) => {
  return (
    <span
      className={cn(
        'bg-primary text-white text-[10px] font-semibold rounded-full h-[18px] w-[18px] overflow-hidden flex items-center justify-center',
        className
      )}
      {...props}
    >
      <span className="tracking-tighter leading-snug mt-[1px] mr-[0.5px]">{count}</span>
    </span>
  );
};

export default CartCount;
